import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_SURGICAL_VS_TOTAL_CASE_TIME_QUERY_KEY } from "../types/CommonTypes";
import { GET_SURGICAL_VS_TOTAL_CASE_TIME_RESPONSE } from "../types/ResponseTypes";

async function getSurgicalVsTotalCaseTime(tenantId: string, hospitalId: string, queryString: string): Promise<GET_SURGICAL_VS_TOTAL_CASE_TIME_RESPONSE> {
  const { data } = await fetcher({
    url: `analytics/surgical-time-vs-total-case-time?${queryString}`,
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data;
}

function useGetSurgicalVsTotalCaseTimeQuery(tenantId: string, hospitalId: string, queryString: string = "") {
  return useQuery({
    queryKey: [
      GET_SURGICAL_VS_TOTAL_CASE_TIME_QUERY_KEY,
      queryString,
      tenantId,
      hospitalId],
    queryFn: () => getSurgicalVsTotalCaseTime(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
  });
}

export default useGetSurgicalVsTotalCaseTimeQuery;
